import React, { useEffect, useRef, useState } from 'react';
import UtilityReadings from '../../staff_pages/utility_data/UtilityReadings';
import TargetRegistry from '../../staff_pages/targets/site_targets/TargetRegistry';
import SensorContainer from '../dashboard_components/sites/sensors/SensorContainer';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import UtilityGraphContainer from '../../metric_graphs/utilities/raw_data/UtilityGraphContainer';
import OpportunityContainer from '../../opportunities/OpportunityContainer';
import SettingsContainer from './settings/SettingsContainer';
import EventsContainer from '../../events/EventsContainer';
import OverviewContainer from '../emission_savings/OverviewContainer';
import ActivityLogContainer from '../../activity_log/ActivityLogContainer';
import SiteConfigPage from './config/SiteConfigPage';
import EmissionsDashboard from '../../emissions/EmissionsDashboard';
import AirCompressor from '../../metric_graphs/utilities/raw_data/air_compressors/AirCompressors';
import SensorLayout from '../dashboard_components/sites/sensors/SensorLayout';
import Boiler from '../../metric_graphs/utilities/boiler/Boiler';
import { useLocation, useParams } from 'react-router-dom';

const SiteManagementPage = props => {
    const {siteId} = useParams();
    const { state, key: navKey } = useLocation();
    const [value, setValue] = useState(state?.tab || 'opportunities');
    
    var init = useRef(true);

    useEffect(() => {
        if(init.current){
            // console.log('sitemgmt')
            init.current = false;
        }
    }, []);

    useEffect(() => {
        setValue(state?.tab ?? 'opportunities');
    }, [siteId, state?.tab]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <div style={{padding:'2%', backgroundColor:'#f5f5f5', minHeight:'95vh'}}>
            <Box sx={{width: '100%', backgroundColor:'rgba(255,255,255,0.4)'}}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'rgb(0,177,168)'
                        },
                        '& .MuiTab-textColorSecondary.Mui-selected': {
                            color: 'rgb(0,177,168)'
                        },
                        '& .MuiTab-textColorSecondary': {
                            color: 'rgb(8,114,182)'
                        },
                    }}
                    aria-label="secondary tabs example"
                    variant="scrollable" 
                    scrollButtons="auto"
                >
                    <Tab value="aircompressor" label="Air Compressor" />
                    <Tab value="boiler" label="Boiler" />
                    <Tab value="opportunities" label="Opportunities" />
                    <Tab value="metrics" label="Raw Data" />
                    <Tab value="impacts" label="Savings" />
                    <Tab value="glidepath" label="Glidepath" />
                    <Tab value="tasks" label="Tasks" />
                    <Tab value="activity" label="Activity log" />
                    <Tab value="utilities" label="Utilities" />
                    <Tab value="targets" label="Targets" />
                    <Tab value="sensors" label="Sensors" />
                    <Tab value="layout" label="Sensor Layout" />
                    <Tab value="settings" label="Report" />
                    <Tab value="configuration" label="Site Properties" />
                </Tabs>
            </Box>

            <br/>
            {value === 'aircompressor' && <AirCompressor key={`metrics-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'boiler' && <Boiler key={`metrics-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'metrics' && <UtilityGraphContainer key={`metrics-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'utilities' && <UtilityReadings key={`utilities-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'targets' && <TargetRegistry userData={props.userData} key={`targets-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'sensors' && <SensorContainer key={`sensors-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'opportunities' && <OpportunityContainer key={`opp-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'tasks' && <EventsContainer key={`tasks-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'activity' && <ActivityLogContainer key={`activity-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'settings' && <SettingsContainer key={`settings-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'impacts' && <OverviewContainer userData={props.userData} key={`impacts-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'glidepath' && <EmissionsDashboard userData={props.userData} page='Trends' isAdminView={true} key={`trends-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'configuration' && <SiteConfigPage key={`config-${siteId}`} siteId={Number(siteId)}/>}
            {value === 'layout' && <SensorLayout userData={props.userData} siteId={Number(siteId)} />}
        </div>
    );
}

export default SiteManagementPage;
